// React
import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Components
import Service from './Service'
import BServices from 'store/blocks/Services'

// Shared
import ProductGroupActions from 'store/v2/redux/actions/product_group'

const Services = ({ cart, lines, services, items, fetchServices }) => {
  useEffect(() => {
    if (cart) {
      fetchServices(cart.id)
    }
  }, [cart?.id, cart?.starts_at, cart?.stops_at])

  const isServiceInCart = useCallback(
    (serviceId) => {
      return items.includes(serviceId)
    },
    [items]
  )

  return (
    <BServices className="bq-service-lines">
      {services.map((service, index) => {
        const inCart = isServiceInCart(service.id)

        return <Service key={service.id} index={index} lines={lines} service={service} inCart={inCart} />
      })}
    </BServices>
  )
}

Services.displayName = 'Services'

Services.propTypes = {
  cart: PropTypes.object,
  lines: PropTypes.object,
  services: PropTypes.object,
  items: PropTypes.object,
  fetchServices: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const lines = state.orm.lines.getAll({ id: props.cart != null ? props.cart.lines : undefined })
  const items = lines.map((line) => line.item_id)
  const enabledServices = state.orm.product_groups.getAll({ product_type: 'service', show_in_store: true })
  const services =
    state.orm.products
      .getAll({ product_type: 'service', product_group_id: enabledServices.pluck('id') })
      .sortBy((product) => enabledServices.getById(product.product_group_id)?.sorting_weight)

  return {
    lines,
    services,
    items
  }
}

const mapDispatchToProps = (_dispatch) => ({
  fetchServices: (cartId) => ProductGroupActions.fetchServices({ cart_id: cartId })
})

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Services)
